export class Room {
  bl_id: string = "";
  fl_id: string = "";
  rm_id: string = "";
  config_id: string = "";
  rm_arrange_type_id: string = "";
  name: string = "";
  max_capacity: number = 0;
  min_required: number = 0;
  num_conflicts: number = 0;
  approval: boolean = false;
  day_start: Date | null = null;
  day_end: Date | null = null;
  mailbox_id: string = "";
  location: string = "";
  info: string = "";
  columns: string = "fl_id,rm_id,name,info";

  constructor(initializer?: any) {
    if (!initializer) return;
    if (initializer.bl_id) this.bl_id = initializer.bl_id;
    if (initializer.fl_id) this.fl_id = initializer.fl_id;
    if (initializer.rm_id) this.rm_id = initializer.rm_id;
    if (initializer.config_id) this.config_id = initializer.config_id;
    if (initializer.rm_arrange_type_id) this.rm_arrange_type_id = initializer.rm_arrange_type_id;
    if (initializer.name) this.name = initializer.name;
    if (initializer.max_capacity) this.max_capacity = initializer.max_capacity;
    if (initializer.min_required) this.min_required = initializer.min_required;
    if (initializer.num_conflicts) this.num_conflicts = initializer.num_conflicts;
    if (initializer.approval) this.approval = initializer.approval;
    if (initializer.day_start) this.day_start = new Date(initializer.day_start);
    if (initializer.day_end) this.day_end = new Date(initializer.day_end);
    if (initializer.mailbox_id) this.mailbox_id = initializer.mailbox_id;
    if (initializer.location) this.location = initializer.location;
    if (initializer.info) this.info = initializer.info;
    if (initializer.columns) this.columns = initializer.columns;
  }

  getIdentifier(): string {
    return `${this.bl_id}||${this.fl_id}||${this.rm_id}||${this.config_id}||${this.rm_arrange_type_id}`;
  }
}
